import React, { Component } from 'react'
import './BackgroundImage.css';
import homeBackground from '../assets/img/background/homeBackground.png'


class BackgroundImage extends Component {
  render() {
    return (
        <div><img className='bg' src={ homeBackground } alt="Background" /></div>
    )
  }
}

export default BackgroundImage
